import React from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";

function UnsupportedField(_ref) {
  var schema = _ref.schema,
      idSchema = _ref.idSchema,
      reason = _ref.reason;
  return /*#__PURE__*/React.createElement("div", {
    className: "unsupported-field"
  }, /*#__PURE__*/React.createElement("p", null, useIntl().formatMessage({
    id: "nv8kkW",
    defaultMessage: [{
      "type": 0,
      "value": "Unsupported field schema"
    }, {
      "type": 5,
      "value": "hasSchema",
      "options": {
        "true": {
          "value": [{
            "type": 0,
            "value": " for field "
          }, {
            "type": 1,
            "value": "schema"
          }]
        },
        "other": {
          "value": []
        }
      }
    }, {
      "type": 5,
      "value": "hasReason",
      "options": {
        "true": {
          "value": [{
            "type": 0,
            "value": ": "
          }, {
            "type": 1,
            "value": "reason"
          }]
        },
        "other": {
          "value": []
        }
      }
    }]
  }, {
    hasSchema: Boolean(idSchema && idSchema.$id),
    schema: /*#__PURE__*/React.createElement("code", null, idSchema.$id),
    hasReason: Boolean(reason),
    reason: /*#__PURE__*/React.createElement("em", null, reason)
  })), schema && /*#__PURE__*/React.createElement("pre", null, JSON.stringify(schema, null, 2)));
}

if (process.env.NODE_ENV !== "production") {
  UnsupportedField.propTypes = {
    schema: PropTypes.object.isRequired,
    idSchema: PropTypes.object,
    reason: PropTypes.string
  };
}

export default UnsupportedField;